import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    mezzi: [],
    singleMezzi: {},
    isLoading: false,
    error: null,
    mezzo: [],
    enumsLoading: {
        mezzo: false,
    },
    enumsError: {
        mezzo: null,
    }
}
const mezziSlice = createSlice({
    name: "mezziData",
    initialState,
    reducers: {
      setMezzi: (state, action) => {
        state.mezzi = action.payload;
        // console.log("setProdotti - New prodotti:", state.mezzi);
      },
      addMezzi: (state, action) => {
        state.mezzi.push(action.payload);
      },
      addMezziId: (state, action) => {
        state.singleMezzi = action.payload;
      },
      updateMezzi: (state, action) => {
        const index = state.mezzi.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.prodotti[index] = action.payload;
        }
      },
      deleteMezzi: (state, action) => {
        state.mezzi = state.mezzi.filter(
          (item) => item.id !== action.payload
        );
      },
      apiRequestStart: (state) => {
        state.isLoading = true;
        state.error = null;
      },
      apiRequestSuccess: (state) => {
        state.isLoading = false;
      },
      apiRequestFailure: (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      },
      setMezzo: (state, action) => {
        state.mezzo = action.payload;
      },
      enumRequestStart: (state, action) => {
        state.enumsLoading[action.payload] = true;
        state.enumsError[action.payload] = null;
      },
      enumRequestSuccess: (state, action) => {
        state.enumsLoading[action.payload] = false;
      },
      enumRequestFailure: (state, action) => {
        const { enumType, error } = action.payload;
        state.enumsLoading[enumType] = false;
        state.enumsError[enumType] = error;
      }
    },
  });
  export const {
    setMezzi,
    addMezzi,
    addMezziId,
    updateMezzi,
    deleteMezzi,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    enumRequestFailure,
    enumRequestStart,
    enumRequestSuccess,
    setMezzo,
  } = mezziSlice.actions;
  // Fix the selectors to consistently use prodottoData
  // Fix the selectors to consistently use the same state path
  export const selectMezzi = (state) => state.mezzi?.mezzi;
  export const selectSingleMezzi = (state) => state.mezzi?.singleMezzi;
  export const selectIsLoading = (state) => state.mezzi?.isLoading;
  export const selectError = (state) => state.mezzi?.error;
  export const selectMezzo = (state) => state.mezzi?.mezzo;
  export default mezziSlice.reducer;